import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTokenModalOpen } from "../RoundToJoin/tocken.slice";
import BuyTokenPopUp from "../../popups/BuyTokenPopup";
import TokenTransferCard from "./TokenTransferCard";
import OtpPopup from "../../popups/OtpPopup";
import SendTokenPopup from "../../popups/SendTokenPopup";
import SuccessPopup from "../../popups/SuccessPopup";
import useDeviceType from "../../Utiles/FindDevice";
import { getData, refreshTocken } from "../../services/api";
import { ReactComponent as UpArrow } from "../../assets/up_red.svg";
import { ReactComponent as DownArrow } from "../../assets/down_green.svg";
import axios from "axios";
import { baseURL } from "../../services/axiosConfig";

const CircularLoader = ({ isMobile = false }) => (
  <tr>
    <td colSpan="5" className="px-6 py-16 text-center">
      <div className="flex justify-center items-center">
        <div
          className={`animate-spin rounded-full border-b-2 border-blue-500 ${isMobile ? "h-8 w-8" : "h-12 w-12"}`}
        ></div>
      </div>
    </td>
  </tr>
);

function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;
  return `${day} ${month} ${hours}:${minutes} ${ampm}`;
}

function getOtherDisplayName(transaction) {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const currUserEmail = userInfo?.email || "";

  const isSent = transaction.from_user?.email && transaction.from_user.email === currUserEmail;

  const otherName = isSent
    ? transaction.to_display_name || transaction.to_user?.email || "-"
    : transaction.from_display_name || transaction.from_user?.email || "-";

  console.log("isSent:", isSent, "otherName:", otherName);
  return otherName;
}

function TokensWithArrow({ transaction }) {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const currUserEmail = userInfo?.email || "";

  const isSent = transaction.from_user?.email && transaction.from_user.email === currUserEmail;

  console.log("TokensWithArrow - isSent:", isSent, "Transaction:", transaction);

  return (
    <span className="flex items-center gap-1 justify-center">
      {isSent ? (
        <UpArrow className="w-4 h-4 mr-0.5" />
      ) : (
        <DownArrow className="w-4 h-4 mr-0.5" />
      )}
      <span
        className={
          isSent ? "text-[#ff4956] font-semibold" : "text-[#00c05b] font-semibold"
        }
        style={{
          fontSize: 16,
        }}
      >
        {transaction.token_count}
      </span>
    </span>
  );
}

function Pagination({ currentPage, totalPages, onPageChange, isMobile = false }) {
  return (
    <div
      className={`flex items-center gap-1 ${isMobile ? "justify-center mt-4" : "justify-end mt-6"}`}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`w-8 h-8 flex items-center justify-center ${isMobile ? "text-xs" : "text-sm"} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M7.5 9L4.5 6L7.5 3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-8 h-8 flex items-center justify-center ${isMobile ? "text-xs" : "text-sm"} font-medium rounded border transition-colors ${page === currentPage ? "bg-blue-500 text-white border-blue-500 shadow-sm" : "text-gray-600 hover:bg-gray-50 border-gray-200 bg-white"}`}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`w-8 h-8 flex items-center justify-center ${isMobile ? "text-xs" : "text-sm"} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M4.5 3L7.5 6L4.5 9"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}

function StatusBadge({ status, isMobile = false }) {
  const isSuccess = status?.toLowerCase() === "success";
  return (
    <div
      className={`inline-flex items-center px-2 py-1 rounded-full ${isMobile ? "text-xs" : "text-xs"} font-medium ${isSuccess ? "bg-green-50 text-green-600 border border-green-200" : "bg-red-50 text-red-600 border border-red-200"}`}
    >
      <div
        className={`${isMobile ? "w-1 h-1" : "w-1.5 h-1.5"} rounded-full mr-1 ${isSuccess ? "bg-green-500" : "bg-red-500"}`}
      />
      {isSuccess ? "Success" : "Failed"}
    </div>
  );
}

const TokenTransfer = () => {
  const dispatch = useDispatch();
  const { isCreateTokenModalOpen } = useSelector((state) => state.token);

  const deviceType = useDeviceType();

  const handleSendTokens = () => setShowSendPopup(true);
  const handleBuyTokens = () => dispatch(createTokenModalOpen(true));

  const [availableTokens, setAvailableTokens] = useState(0);
  const totalAmountWon = 12829;
  const totalWonTokens = 128;
  const currency = "AED";

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [transactions, setTransactions] = useState([]);

  const [showSendPopup, setShowSendPopup] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [transferId, setTransferId] = useState("");
  const [formData, setFormData] = useState({});

  const [otpEmail, setOtpEmail] = useState("");
  const [otpTokens, setOtpTokens] = useState("");
  const [otpReceiverEmail, setOtpReceiverEmail] = useState("");
  const [otpSenderEmail, setOtpSenderEmail] = useState("");
  const [otpDisplayName, setOtpDisplayName] = useState("");

  useEffect(() => {
    console.log("UserInfo from localStorage:", JSON.parse(localStorage.getItem("userInfo")));
    const fetchAvailableTokens = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const userData = await axios.get(`${baseURL}/accounts/user/me`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        });
        console.log("User Data:", userData);
        setAvailableTokens(userData.data.available_tokens || 0);
      } catch (err) {
        console.error("Error fetching available tokens:", err);
        if (
          err?.response?.status === 401 &&
          err?.response?.data?.type === "Access"
        ) {
          refreshTocken();
        }
      }
    };
    fetchAvailableTokens();
  }, []);

  const fetchTransactions = async (page) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/accounts/token-transactions/`, {
        params: { page: page.toString() },
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      });
      console.log("API Response:", response);
      const transactions = response?.data?.results || response || [];
      setTransactions(transactions);
      setTotalPages(Math.ceil((response?.data?.count || 0) / 10) || 1);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      if (
        error?.response?.status === 401 &&
        error?.response?.data?.type === "Access"
      ) {
        refreshTocken();
      } else {
        setTransactions([]);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const handleSendClose = () => setShowSendPopup(false);

  const handleSendSubmit = (data) => {
    console.log('Received data from SendTokenPopup:', data);
    if (!data.transferId) {
      console.warn('Warning: No transferId received from SendTokenPopup');
    }
    setFormData({
      tokens: data.tokens,
      displayName: data.displayName,
      email: data.email,
      name: data.name,
    });
    setTransferId(data.transferId);
    setShowSendPopup(false);
    setShowOtpPopup(true);
    setOtpEmail(data.email);
    setOtpTokens(data.tokens);
    setOtpReceiverEmail(data.email);
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setOtpSenderEmail(userInfo.email);
    setOtpDisplayName(data.displayName);
    console.log('Set transferId to:', data.transferId);
  };

  const handleOtpClose = () => setShowOtpPopup(false);

  const handleOtpVerify = (responseData) => {
    console.log("Transfer completed:", responseData);
    setShowOtpPopup(false);
    setShowSuccessPopup(true);
    fetchTransactions(currentPage);
  };

  const handleOtpResend = (newResponseData) => {
    console.log("New OTP sent:", newResponseData);
    setTransferId(newResponseData.transfer_id);
  };

  const handleSuccessClose = () => setShowSuccessPopup(false);

  if (deviceType === "mobile") {
    return (
      <div className="p-3 min-h-screen bg-gray-50">
        {/* {isCreateTokenModalOpen && <BuyTokenPopUp component="tokenTransfer" />} */}
        {showSendPopup && (
          <SendTokenPopup
            onClose={handleSendClose}
            onSubmit={handleSendSubmit}
            availableTokens={availableTokens}
            setAvailableTokens={setAvailableTokens}
          />
        )}
        {showOtpPopup && (
          <OtpPopup
            onClose={handleOtpClose}
            onVerify={handleOtpVerify}
            onResend={handleOtpResend}
            tokens={otpTokens}
            receiverEmail={otpReceiverEmail}
            senderEmail={otpSenderEmail}
            displayName={otpDisplayName}
            transferId={transferId}
            formData={formData}
            availableTokens={availableTokens}
            setAvailableTokens={setAvailableTokens}
          />
        )}
        {showSuccessPopup && <SuccessPopup onClose={handleSuccessClose} />}

        <TokenTransferCard
          availableTokens={availableTokens}
          setAvailableTokens={setAvailableTokens}
          totalAmountWon={totalAmountWon}
          totalWonTokens={totalWonTokens}
          currency={currency}
          onSendTokens={handleSendTokens}
          onBuyTokens={handleBuyTokens}
        />

        <div className="text-sm font-bold text-[#0A1A2F] mt-6 mb-2 px-2 text-left">
          Send & Receive Token History
        </div>

        <div className="overflow-x-auto bg-white rounded-xl shadow">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">
                  Transaction ID
                </th>
                <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">
                  Date
                </th>
                <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">
                  From / To
                </th>
                <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">
                  Tokens
                </th>
                <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <CircularLoader isMobile={true} />
              ) : transactions.length > 0 ? (
                transactions.map((transaction, index) => (
                  <tr
                    key={transaction.id}
                    className={index % 2 !== 0 ? "bg-[#f6faff]" : "bg-white"}
                  >
                    <td className="px-3 py-3 text-xs text-gray-600 font-mono whitespace-nowrap">
                      {transaction.id}
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 whitespace-nowrap">
                      {formatDate(transaction.timestamp)}
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 text-center">
                      {transaction.other_user_name}
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 text-center">
                      <TokensWithArrow transaction={transaction} />
                    </td>
                    <td className="px-3 py-3">
                      <StatusBadge status={transaction.status} isMobile={true} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-3 py-6 text-center text-gray-500 text-xs">
                    No token transfers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {!loading && (
          <div className="p-3 border-t border-gray-200 bg-white">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              isMobile={true}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="w-full mt-4">
      {/* {isCreateTokenModalOpen && <BuyTokenPopUp component="tokenTransfer"/>} */}
      {showSendPopup && (
        <SendTokenPopup
          onClose={handleSendClose}
          onSubmit={handleSendSubmit}
          availableTokens={availableTokens}
          setAvailableTokens={setAvailableTokens}
        />
      )}
      {showOtpPopup && (
        <OtpPopup
          onClose={handleOtpClose}
          onVerify={handleOtpVerify}
          onResend={handleOtpResend}
          tokens={otpTokens}
          receiverEmail={otpReceiverEmail}
          senderEmail={otpSenderEmail}
          displayName={otpDisplayName}
          transferId={transferId}
          formData={formData}
          availableTokens={availableTokens}
          setAvailableTokens={setAvailableTokens}
        />
      )}
      {showSuccessPopup && <SuccessPopup onClose={handleSuccessClose} />}
      <TokenTransferCard
        availableTokens={availableTokens}
        setAvailableTokens={setAvailableTokens}
        totalAmountWon={totalAmountWon}
        totalWonTokens={totalWonTokens}
        currency={currency}
        onSendTokens={handleSendTokens}
        onBuyTokens={handleBuyTokens}
      />
      <div className="font-archivo text-lg font-bold text-[#0A1A2F] max-w-7xl xl:max-w-[1600px] mx-auto mt-8 mb-4 px-2">
        Send & Receive Token History
      </div>
      <div className="max-w-7xl xl:max-w-[1600px] mx-auto">
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                  <th className="px-6 py-4 text-left text-sm font-semibold font-archivo">
                    Transaction ID
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold font-archivo">
                    Date
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold font-archivo">
                    From / To
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold font-archivo">
                    Tokens
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold font-archivo">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loading ? (
                  <CircularLoader />
                ) : transactions.length > 0 ? (
                  transactions.map((transaction, index) => (
                    <tr
                      key={transaction.id}
                      className={index % 2 !== 0 ? "bg-[#f6faff]" : "bg-white"}
                    >
                      <td className="px-6 py-4 text-sm text-[#00000099] font-archivo font-mono">
                        {transaction.id}
                      </td>
                      <td className="px-6 py-4 text-sm text-center text-[#00000099] font-archivo">
                        {formatDate(transaction.timestamp)}
                      </td>
                      <td className="px-6 py-4 text-sm text-[#00000099] text-center font-archivo">
                        {transaction.other_user_name}
                      </td>
                      <td className="px-6 py-4 text-sm text-center font-archivo">
                        <TokensWithArrow transaction={transaction} />
                      </td>
                      <td className="px-6 py-4 text-center font-archivo">
                        <StatusBadge status={transaction.status} />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-6 py-8 text-center text-gray-500 font-archivo">
                      No token transfers found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {!loading && (
          <div className="px-6 py-2">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TokenTransfer;